module.exports = __webpack_public_path__ + "img/www.25461fe6.svg";